export default "__VITE_ASSET__B65lIe3M__"